const map = {
	"./2022-10-17_20h40_25.png": 5119,
	"./2022-10-17_21h19_13.png": 2127,
	"./2022-10-17_21h40_37.png": 2827,
	"./2022-10-17_21h42_28.png": 4021,
	"./2022-10-17_21h43_22.png": 6296,
	"./2022-10-17_21h44_55.png": 3707
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7;